<template>
  <!-- <div
    class="angle"
    :style="`--numberValue:${numberValue3}deg;--numberValue2:${numberValue2}deg;`"
  >
    <div class="angle-all">
      <div class="angle-1"></div>
      <div class="angle-2"></div>
      <div class="angle-3"></div>
      <div class="angle-4"></div>
      <div class="angle-5"></div>
    </div>
    <div class="d-all">
      <div class="d0">0°</div>
      <div class="d1">-0.2°</div>
      <div class="d2">0.2°</div>
      <div class="d3">-0.5°</div>
      <div class="d4">0.5°</div>
      <div class="d5">-1°</div>
      <div class="d6">1°</div>
    </div>
    <div
      :key="key"
      class="pointer"
      :class="myStatic ? 'pointerAnimateNo' : 'pointerAnimate'"
      id="pointer"
      @animationiteration="animationiteration"
    >

      <div></div>
      <div></div>
      <div></div>
    </div>
  </div> -->
  <div class="angle">
    <div :id="'angle'+id" class="Canvas"></div>
  </div>
</template>

<script>
export default {
  props: {
    numberValue: {
      type: Number,
      default: 0,
    },
    myStatic: {
      type: Boolean,
      default: false,
    },
    id:{
      type: String,
      default: "",
    }
  },
  watch: {
    numberValue: {
      handler(newValue, oldValue) {
        var myChart = this.$echarts.init(document.getElementById("angle"+this.id));
        myChart.setOption({
          series: [
            {
              detail: {
                valueAnimation: true,
                formatter: function (value) {
                  let myvalue = value;
                  if (value > 60) {
                    myvalue = ((value - 60) / 60 + 0.5).toFixed(2);
                  } else if (value >= 30) {
                    myvalue = ((value - 30) / 100 + 0.2).toFixed(2);
                  } else if (value < -60) {
                    myvalue = ((value + 60) / 60 - 0.5).toFixed(2);
                  } else if (value < -30) {
                    myvalue = ((value + 30) / 100 - 0.2).toFixed(2);
                  } else {
                    myvalue = (value / 150).toFixed(2);
                  }
                  return myvalue + "°";
                },
                color: "inherit",
                fontSize: 10,
              },
              data: [
                {
                  value: newValue,
                },
              ],
            },
          ],
        });

        console.log("测试渲染2222");
        // if (!this.myStatic) {
        //   let pointerDIV = document.querySelector("#pointer");
        //   setTimeout(() => {
        //     pointerDIV.className = pointerDIV.className.replace(
        //       " pointerAnimate",
        //       " pointerAnimateNo"
        //     );
        //   }, 900);
        //   setTimeout(() => {
        //     pointerDIV.className = pointerDIV.className.replace(
        //       " pointerAnimateNo",
        //       " pointerAnimate"
        //     );
        //     this.numberValue2 = oldValue;
        //     this.numberValue3 = newValue;
        //   }, 1000);
        // }
      },
    },
    // numberValue2: {
    //   handler(newValue, oldValue) {
    //     var myChart = this.$echarts.init(document.getElementById("angle"));
    //     myChart.setOption({
    //       series: [
    //         {
    //           data: [
    //             {
    //               value: 0.5,
    //             },
    //           ],
    //         },
    //       ],
    //     });
    //   },
    // },
  },
  data() {
    return {
      // value: 0,
      numberValue2: 0,
      numberValue3: 0,
      key: 0,
    };
  },
  mounted() {
    // this.numberValue3 = this.numberValue;
    // this.key++;
    this.echartsInit();
    console.log("测试渲染");
  },
  methods: {
    animationiteration() {
      // this.numberValue2 = JSON.parse(JSON.stringify(this.numberValue));
      // console.log(11, this.numberValue2, this.numberValue);
    },
    echartsInit() {
      var myChart = this.$echarts.init(document.getElementById("angle"+this.id));
      var options = {
        series: [
          {
            type: "gauge",
            radius: "100%",
            min: -90,
            max: 90,
            splitNumber: 6,
            axisLine: {
              lineStyle: {
                width: 10,
                color: [
                  [0.16666, "#91656D"],
                  [0.33333, "#C8CD85"],
                  [0.5, "#7FB8BA"],
                  [0.66666, "#7FB8BA"],
                  [0.83333, "#C8CD85"],
                  [1, "#91656D"],
                ],
              },
            },
            pointer: {
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              show: false,
              distance: -30,
              length: 8,
              lineStyle: {
                color: "#fff",
                width: 2,
              },
            },
            splitLine: {
              distance: -10,
              length: 10,
              lineStyle: {
                color: "#fff",
                width: 4,
              },
            },
            axisLabel: {
              distance: 11,
              fontSize: 10,
              color: "#fff",
              formatter: function (value) {
                let myvalue = value;
                switch (value) {
                  case -90:
                    myvalue = -1;
                    break;
                  case -60:
                    myvalue = -0.5;
                    break;
                  case -30:
                    myvalue = -0.2;
                    break;
                  case 0:
                    myvalue = 0;
                    break;
                  case 30:
                    myvalue = 0.2;
                    break;
                  case 60:
                    myvalue = 0.5;
                    break;
                  case 90:
                    myvalue = 1;
                    break;

                  default:
                  // code
                }
                return myvalue + "°";
              },
            },
            detail: {
              valueAnimation: true,
              formatter: function (value) {
                let myvalue = value;
                if (value > 60) {
                  myvalue = ((value - 60) / 60 + 0.5).toFixed(2);
                } else if (value > 30) {
                  myvalue = ((value - 30) / 100 + 0.2).toFixed(2);
                } else if (value < -60) {
                  myvalue = ((value + 60) / 60 - 0.5).toFixed(2);
                } else if (value < -30) {
                  myvalue = ((value + 30) / 100 - 0.2).toFixed(2);
                } else {
                  myvalue = (value / 90).toFixed(2);
                }
                return myvalue + "°";
              },
              color: "inherit",
              fontSize: 10,
            },
            data: [
              {
                value: this.numberValue,
              },
            ],
          },
        ],
      };

      myChart.setOption(options);

      console.log("测试渲染1111");
    },
  },
};
</script>

<style lang="scss" scoped>
// .angle {
//   //   background-color: white;
//   position: relative;
//   .angle-all {
//     position: relative;
//     overflow: hidden;
//     height: 100%;
//     width: 100%;
//     .angle-1,
//     .angle-2,
//     .angle-3,
//     .angle-4,
//     .angle-5 {
//       position: absolute;
//       top: 0px;
//       left: 0px;
//       height: 200%;
//       width: 100%;
//       border-radius: 100%;
//       clip-path: polygon(0 0, 0 50%, 100% 50%, 100% 0);
//     }
//     .angle-3 {
//       background-color: green;
//       transform: rotate(60deg);
//     }
//     .angle-2 {
//       background-color: yellow;
//       transform: rotate(30deg);
//     }
//     .angle-1,
//     .angle-5 {
//       background-color: red;
//     }
//     .angle-4 {
//       background-color: yellow;
//       transform: rotate(120deg);
//     }
//     .angle-5 {
//       transform: rotate(150deg);
//     }
//   }
//   .d-all {
//     .d0,
//     .d1,
//     .d2,
//     .d3,
//     .d4,
//     .d5,
//     .d6 {
//       position: absolute;
//       color: white;
//     }
//     .d0 {
//       top: -15px;
//       left: 49%;
//     }
//     .d1,
//     .d2 {
//       top: 0px;
//     }
//     .d1 {
//       left: 18%;
//     }
//     .d2 {
//       right: 18%;
//     }
//     .d3,
//     .d4 {
//       top: 50px;
//     }
//     .d3 {
//       left: -10px;
//     }
//     .d4 {
//       right: -10px;
//     }
//     .d5,
//     .d6 {
//       bottom: 0px;
//     }
//     .d5 {
//       left: -20px;
//     }
//     .d6 {
//       right: -20px;
//     }
//   }

//   .pointerAnimate {
//     animation: pointerA 0.9s;
//     animation-fill-mode: forwards;
//   }
//   .pointerAnimateNo {
//     transform: rotate(var(--numberValue));
//   }
//   .pointer {
//     height: 100%;
//     width: 20px;
//     // background-color: white;
//     position: absolute;
//     left: calc(50% - 10px);
//     bottom: 0px;
//     transform-origin: bottom center;
//     // background-color: aqua;
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     > div {
//       background-color: black;
//     }
//     > div:nth-child(1) {
//       width: 20px;
//       height: 30px;
//       clip-path: polygon(50% 0, 100% 100%, 0 100%);
//     }
//     > div:nth-child(2) {
//       margin-top: -10px;
//       width: 6px;
//       flex: 1;
//     }
//     > div:nth-child(3) {
//       margin-top: 0px;
//       width: 10px;
//       height: 10px;
//       border-radius: 50%;
//     }
//   }
//   @keyframes pointerA {
//     0% {
//       transform: rotate(var(--numberValue2));
//       // transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(var(--numberValue));
//     }
//   }
// }
.angle {
  position: relative;

  .Canvas {
    height: 100%;
    width: 100%;
  }
}
</style>